export default __webpack_public_path__ + "static/media/discoverBooks@2x.e0b67752.png";